"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingContext = void 0;
const react_1 = require("react");
const constants_1 = require("../constants");
const utils_1 = require("../utils");
exports.TrackingContext = (0, react_1.createContext)(undefined);
const generateHomeHitConfig = (currentPageName, nextPageName, isOpenDoor, isReduced, visibleOn) => {
    const isDiscoveryHome = visibleOn && visibleOn.every((elem) => elem === constants_1.VisibilityContext.SEO);
    return {
        name: 'Click on Header Tab',
        properties: {
            'Access Page Name': `${currentPageName} homepage`,
            'Interaction Type': 'Click',
            'Open Door': isOpenDoor,
            'Page Name': isDiscoveryHome ? `${nextPageName} SEO Page` : `${nextPageName} homepage`,
            'Page Version': isReduced ? 'Reduced homepage' : 'home default',
        },
    };
};
const generateBrandHitConfig = (pageName, brandName, opCode, isOpenDoor) => ({
    name: 'Click on header brand',
    properties: {
        'Brand Name': brandName,
        Category: 'Ventes en cours',
        'Interaction Type': 'Click',
        'Open Door': isOpenDoor,
        'Operation Code': opCode,
        'Page Name': `${pageName} homepage`,
    },
});
const generateCategoryHitConfig = (universe, name, isOpenDoor) => ({
    name: 'Use Homepage Category',
    properties: {
        Action: 'Filter',
        'Category Name': universe,
        'Category activation': true,
        'Interaction Type': 'Click',
        'Open Door': isOpenDoor,
        'Page Name': `${universe} homepage`,
        'Sub Category Name': name,
    },
});
const generateHomeModuleHitConfig = (universe, name, isOpenDoor) => ({
    name: 'Use Homepage Anchor',
    properties: {
        Filter: (0, utils_1.slugify)(name),
        'Filter Category': 'Generic',
        'Filter access': 'Header',
        'Interaction Type': 'Click',
        'Open Door': isOpenDoor,
        'Page Name': `${universe} homepage`,
    },
});
const generateMarketingBannerHitConfig = (pageName, bannerName, isOpenDoor) => ({
    name: 'Click Marketing Banner',
    properties: {
        'Banner Name': bannerName,
        'Banner Type': 'Classic',
        Category: 'Header',
        'Open Door': isOpenDoor,
        'Page Name': `${pageName} homepage`,
    },
});
const generateLateralMenuHitConfig = (pageName, id) => {
    const isLeClub = id === 'nav_le_club';
    if (!isLeClub)
        return undefined;
    return {
        name: 'Click',
        properties: {
            'Click Name': 'The Club Menu',
            'Page Name': `${pageName} homepage`,
        },
    };
};
const useTracking = () => {
    const trackingConfig = (0, react_1.useContext)(exports.TrackingContext);
    return Object.assign({ generateBrandHitConfig,
        generateCategoryHitConfig,
        generateHomeHitConfig,
        generateHomeModuleHitConfig,
        generateMarketingBannerHitConfig,
        generateLateralMenuHitConfig }, trackingConfig);
};
exports.default = useTracking;
